// extracted by mini-css-extract-plugin
export default {"askQuestionTopText":"W2-z","yourQuestionLabel":"X2-z","notAuthedMessage":"Y2-z","form":"Z2-z","textarea":"_2-z","error":"a3-z","disabled":"b3-z","edited":"c3-z","submit":"d3-z"};